import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=f5645c8c&scoped=true"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5645c8c",
  null
  
)

export default component.exports